export const CONTENT_PAG = {
    PAG_MENS: "pagina_mensaje",
    PAG_CONS: "pagina_consideraciones",
    PAG_REGI: "pagina_infoDevRegExi",
    PAG_LAYO: "pagina_layout",
    PAG_REIN: "pagina_reinversion"
};